import defaultConfiguration from '../config/default.json';
import readConfig from './readClientConfiguration';

export const METHOD_STORE = 'storepickup';
export const METHOD_MATRIX = 'matrixrate';
export const GLS_PARCELLSHOP = 'glsparcelshop';
export const countryCode = readConfig(defaultConfiguration, 'countryCode').substr(-2);
